import { render, staticRenderFns } from "./activity-form-text-preview.vue?vue&type=template&id=f135920c&scoped=true&"
import script from "./activity-form-text-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-text-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-text-preview.vue?vue&type=style&index=0&id=f135920c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f135920c",
  null
  
)

component.options.__file = "activity-form-text-preview.vue"
export default component.exports